import {
  SingleProviderConfig,
  ShopType,
  CheckoutType,
  CrossSellType,
} from 'types';
import { allLeadMode, getDefaultCrossSellAction } from 'config';
import {
  ATT,
  Brightspeed,
  BrightspeedV2,
  CenturyLink,
  QuantumFiber,
  Frontier,
  Windstream,
  CincinnatiBell,
  Verizon,
  VerizonFWA,
  Comcast,
  Cox,
  Spectrum,
  Mediacom,
  Optimum,
  Wave,
  Grande,
  RCN,
  WOW,
  TDS,
  FidiumFiber,
} from 'config/providers';
import { VerizonTheme } from 'config/themes';

export const VerizonDeals: SingleProviderConfig = {
  name: 'VerizonDeals',
  micrositeCode: 'Verizon',
  mainProvider: Verizon,
  shopType: ShopType.SINGLE_PROVIDER,
  syntheticProviders: [VerizonFWA],
  domain: 'verizondeals.com',
  homepage: 'https://verizondeals.com',
  title: 'Verizon Authorized Dealer',
  fallbackPhoneNumber: '855-272-8393',
  fallbackLeadModePhoneNumber: '877-649-1240',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: VerizonTheme,
  needsDcSession: false,
  source: 'Verizon',
  noOffersRetry: 2,
  getCrossSellAction: getDefaultCrossSellAction,
  getCheckoutType: allLeadMode,
  crossSellProviders: [],
  updaterCrossSellActive: true,
  updaterCrossSellProviders: [
    ATT,
    Brightspeed,
    BrightspeedV2,
    CenturyLink,
    QuantumFiber,
    Frontier,
    Windstream,
    CincinnatiBell,
    Comcast,
    Cox,
    Spectrum,
    Mediacom,
    Optimum,
    Wave,
    Grande,
    RCN,
    WOW,
    TDS,
    FidiumFiber,
  ],
};
